import { IconText } from '@delmonicos/shared-design-system-react/src/components/icon-text/icon-text';
import {
  GapEnum,
  Stack,
} from '@delmonicos/shared-design-system-react/src/components/stack/stack';
import { Tag } from '@delmonicos/shared-design-system-react/src/components/tag/tag';
import { RfidBadgeOrderStatus } from '@delmonicos/shared-sdk/libs/cpms/src/libs/user-service-lib/src/wrapper/enums/rfid-badge-order-status.enum';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import { mapEmspBoRfidBadgeOrderStatusToStyle } from '../emsp-bo-rfid-badge-order-status.helper';
import * as css from './emsp-bo-rfid-badge-order-status-filter.module.scss';

interface EmspBoRfidBadgeOrderStatusFilterControllerProps {
  onChange: (item?: RfidBadgeOrderStatus) => void;
  selectedItemId: RfidBadgeOrderStatus | undefined;
}

export const EmspBoRfidBadgeOrderStatusFilterController = ({
  onChange,
  selectedItemId,
}: EmspBoRfidBadgeOrderStatusFilterControllerProps): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  const { t } = useTranslation();

  // DATA FETCHING /////////////////////////////////////////////////////////////

  const statusList = Object.values(RfidBadgeOrderStatus).map((status) => ({
    key: status,
    label: t(`delmonicos-shared-sdk.enums-rfid-badge-order-status.${status}`),
    color: mapEmspBoRfidBadgeOrderStatusToStyle(status).color,
  }));

  // RENDER ////////////////////////////////////////////////////////////////////

  return (
    <Stack direction="column" gap={GapEnum.M}>
      <IconText
        iconName="credit-card-refresh"
        text={t('delmonicos-shared-sdk.outputs-rfid-badge-order.status')}
      />
      <div className={css.buttonTagList}>
        {statusList.map((item) => (
          <button
            key={item.key}
            type="button"
            className={css.buttonTag}
            onClick={() =>
              onChange(item.key === selectedItemId ? undefined : item.key)
            }>
            <Tag
              className={classNames(
                item.color,
                item.key === selectedItemId && css.selected,
                css.tag,
              )}>
              {item.label}
            </Tag>
          </button>
        ))}
      </div>
    </Stack>
  );
};
